import { createReducers, createActions, request } from '../../../utils/';
import { combineReducers } from 'redux';
import Urls from '../../../../config/index';
import { message } from 'antd';
const { MonitorUrl } = Urls;

const path = name => `app/pages/taskVolume/${name}`;
const models = {
    list: {
        data: [],
        handlers: {
            get(state, action) {
                return action.payload;
            },
            add(state, action) {
                return [...action.payload, ...state];
            },
            del(state, action) {
                return state.filter(item => item._id !== action.payload);
            },
            update(state, action) {
                return state.map(item => (item._id === action.payload._id ? action.payload : item));
            },
        },
    },
    listProvince: {
        data: [],
        handlers: {
            getListProvince(state, action) {
                return action.payload;
            },
            addListProvince(state, action) {
                return [...action.payload, ...state];
            },
            delListProvince(state, action) {
                return state.filter(item => item._id !== action.payload);
            },
            updateListProvince(state, action) {
                return state.map(item => (item._id === action.payload._id ? action.payload : item));
            },
        },
    },
    listAll: {
        data: [],
        handlers: {
            getAll(state, action) {
                return action.payload;
            },
        },
    },
    transferData: {
        data: {
            selectedRowKeys: [],
        },
        handlers: {
            getTransferData(state, action) {
                return {...state, ...action.payload};
            },
        },
    },
    pagination: {
        data: {
            current: 1,
            total: 0,
            pageSize: 10,
        },
        handlers: {
            changePagination(state, action) {
                return {
                    ...state,
                    ...action.payload,
                };
            },
        },
    },
    searchValues: {
        data: {},
        handlers: {
            changeSearchValues(state, action) {
                return action.payload;
            },
        },
    },
    uiStatus: {
        data: {
            isLoading: false,
            isUpdateShow: false,
            isSendCommend: false,
            isProvinceLoading: false,
        },
        handlers: {
            changeUiStatus(state, action) {
                return {
                    ...state,
                    ...action.payload,
                };
            },
        },
    },
    currentSelectId: {
        data: '',
        handlers: {
            changeCurrentSelectId(state, action) {
                return action.payload;
            },
        },
    },
};

export const actions = createActions(models, path);

export default combineReducers(createReducers(models, path));

const formatGetParams = getState => {
    const state = getState().taskVolume;
    const searchValue = state.searchValues || {};

    const params = {
        ...searchValue,
        page: state.pagination.current,
        pageSize: state.pagination.pageSize,
    };
    return params;
};

/**
 * 获取任务量
 */
export const asyncGet = () => {
    return async (dispatch, getState) => {
        try {
            dispatch(
                actions.changeUiStatus({
                    isLoading: true,
                }),
            );
            // 下面的请求和结果返回需要根据接口来实现
            let result = await request(MonitorUrl.getDayTaskInfo, 'POST',formatGetParams(getState));
            result.sort((a, b) => Date.parse(new Date(a.date)) - Date.parse(new Date(b.date)));
            dispatch(actions.get(result));
            // dispatch(actions.changePagination({total: result.total}));
        } catch (e) {
            throw e;
        } finally {
            dispatch(
                actions.changeUiStatus({
                    isLoading: false,
                }),
            );
        }
    };
};


/**
 * 获取地区任务量
 */
export const asyncProvinceGet = () => {
    return async (dispatch, getState) => {
        try {
            dispatch(
                actions.changeUiStatus({
                    isProvinceLoading: true,
                }),
            );
            // 下面的请求和结果返回需要根据接口来实现
            let result = await request(MonitorUrl.getAppointProvince, 'POST',formatGetParams(getState));
            result.sort((a, b) => Date.parse(new Date(a.date)) - Date.parse(new Date(b.date)));
            result.map(item => {
                item.key = item.province;
                let tasks = item.tasks;
                if (tasks != undefined) {
                    tasks.map(t => {
                            t.key = t.taskId;
                            return t;
                        }
                    );
                }
                return item;
            });
            dispatch(actions.getListProvince(result));
            // dispatch(actions.changePagination({total: result.total}));
        } catch (e) {
            throw e;
        } finally {
            dispatch(
                actions.changeUiStatus({
                    isProvinceLoading: false,
                }),
            );
        }
    };
};


// WEBPACK FOOTER //
// ./pages/StatisticalAnalysis/taskVolume/reducers.js